<app-add-reference-card [desc]="noDataMessage" *ngIf="dataSource.data.length < 1">
</app-add-reference-card>
<div class="scrollmenu">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 data-grid-table"
    *ngIf="dataSource.data.length > 0">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
      <th mat-header-cell *matHeaderCellDef>
        {{column.header}}
      </th>
      <div *ngIf="column.columnDef=='Id'; else elseBlock">
        <td mat-cell *matCellDef="let row; index as i" class="parent">
          <div class="show">{{i+1}}</div>
          <div class="hide" *ngIf="!row.isDeleted && !row.Strikethrough">
            <a (click)="editItem(row)">
              <div class="row-button">
                <mat-icon title="Edit">edit</mat-icon>
              </div>
            </a>
            <a (click)="deleteItem(row)">
              <div class="row-button">
                <mat-icon title="Discard">delete</mat-icon>
              </div>
            </a>
          </div>
        </td>
      </div>
      <ng-template #elseBlock>
        <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough} ">
          {{column.cell(row)}}
        </td>
      </ng-template>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-paginator [ngClass]="{'d-none': dataSource.data.length < 1}" [length]="dataSource.data.length" [pageSize]="5"
  [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
</mat-paginator>